<template>
    <div>
        <el-form ref="form" label-position="top"  label-width="80px">
            <formTitle title="學生相片 Student’s Photo"></formTitle>
            <div class="upload-box">
                <upload :disabled="isView" :fileType="['jpeg','jpg','png']" @childByValue="childByValue('studentPhoto',$event)" :imageurl="studentPhoto ? studentPhoto.path : ''"></upload>
                <div class="upload-text">
                    <div class="upload-text-title">Acceptable File Format :</div>
                    <div>Image type : JPEG、JPG</div>
                    <div>File size : 50Mbytes or below</div>
                
                    <div class="upload-text-title">Acceptable Dimension :</div>
                    <div class="wordWrap">Captured by scanner (72dpi) - Photograph size: 40 mm(W) x 50 mm(H)</div>
                    <div class="wordWrap">Captured by digital camera - Image size: 1200 px(W) x 1600 px(H)</div>
                </div>
                <div>如上傳錯誤檔案，可按瀏覽重新上傳</div>
            </div>
            <formTitle title="學生的出生證明書及香港身份證／護照 Student’s Birth Certificate and HKID Card / Passport"></formTitle>
            <div class="upload-box">
                 <!-- <upload :disabled="isView" :fileType="['jpeg','jpg','png']" @childByValue="childByValue('birthCertificate',$event)"  :imageurl = "birthCertificate.path"></upload> -->
                 <upload :disabled="isView" :fileType="['pdf','jpeg','jpg','png']" :imageurl="item.path" class="upload-list" v-for="(item,index) in birthCertificate" @childByValue="childByValueMore('birthCertificate',index,$event)" :key="index" :isImgDom="false"></upload>
                <el-button v-if="!isView" @click="onAdd(1)" icon="el-icon-plus" type="primary">
                                        增加 Add
                                    </el-button>
                <div class="upload-text">
                    <div class="upload-text-title">Acceptable File Format :</div>
                    <div>Image type : JPEG、JPG</div>
                    <div>File size : 50Mbytes or below</div>
                </div>
                <div>如上傳錯誤檔案，可按瀏覽重新上傳</div>
            </div>
            <!-- <formTitle title="最近三年成績表 Academic Reports of the Recent Three Years"></formTitle>
            <div class="upload-box">
                <upload :disabled="isView" :fileType="['pdf','jpeg','jpg','png']" :imageurl="item.path" class="upload-list" v-for="(item,index) in scoreSheet" @childByValue="childByValueMore('scoreSheet',index,$event)" :key="index" :isImgDom="false"></upload>
                <el-button v-if="!isView" @click="onAdd(2)" icon="el-icon-plus" type="primary">
                                        增加 Add
                                    </el-button>
                <div class="upload-text">
                    <div class="upload-text-title">Acceptable File Format :</div>
                    <div>Image type : JPEG, PDF</div>
                    <div>File size : 50Mbytes or below</div>
                </div>
                <div>如上傳錯誤檔案，可按瀏覽重新上傳</div>
            </div> -->
            <!-- <formTitle title="最近三年獎狀影印本 Award Certificates of the Recent Three Years (選填 Optional)"></formTitle>
            <div class="upload-box">
                <upload :disabled="isView" :fileType="['pdf','jpeg','jpg','png']" :imageurl="item.path" class="upload-list" v-for="(item,index) in certificateAward" @childByValue="childByValueMore('certificateAward',index,$event)" :key="index" :isImgDom="false"></upload>
                <el-button v-if="!isView" @click="onAdd(3)" icon="el-icon-plus" type="primary">
                                        增加 Add
                                    </el-button>
                <div class="upload-text">
                    <div class="upload-text-title">Acceptable File Format :</div>
                    <div>Image type : JPEG, PDF</div>
                    <div>File size : 50Mbytes or below</div>
                </div>
                <div>如上傳錯誤檔案，可按瀏覽重新上傳</div>
            </div> -->
            <!-- <formTitle title="最近三年學術以外成就的証明 Non-academic Reports of the Recent Three Years  (選填 Optional)"></formTitle>
            <div class="upload-box">
                <upload :disabled="isView" :fileType="['pdf','jpeg','jpg','png']" :imageurl="item.path" class="upload-list" v-for="(item,index) in achievement" @childByValue="childByValueMore('achievement',index,$event)" :key="index" :isImgDom="false"></upload>
                <el-button v-if="!isView" @click="onAdd(4)" icon="el-icon-plus" type="primary">
                                        增加 Add
                                    </el-button>
                <div class="upload-text">
                    <div class="upload-text-title">Acceptable File Format :</div>
                    <div>Image type : JPEG, PDF</div>
                    <div>File size : 50Mbytes or below</div>
                </div>
                <div>如上傳錯誤檔案，可按瀏覽重新上傳</div>
            </div> -->
            <!-- <formTitle title="現時/最後就讀學校之校長推薦信 Recommendation Letter from the Principal of the Present/Last School  (選填 Optional)"></formTitle>
            <div class="upload-box">
                <upload :disabled="isView" :fileType="['pdf','jpeg','jpg','png']" :imageurl="item.path" class="upload-list" v-for="(item,index) in letterRecommendation" @childByValue="childByValueMore('letterRecommendation',index,$event)" :key="index" :isImgDom="false"></upload>
                <el-button v-if="!isView" @click="onAdd(5)" icon="el-icon-plus" type="primary">
                                        增加 Add
                                    </el-button>
                <div class="upload-text">
                    <div class="upload-text-title">Acceptable File Format :</div>
                    <div>Image type : JPEG, PDF</div>
                    <div>File size : 50Mbytes or below</div>
                
                </div>
                <div>如上傳錯誤檔案，可按瀏覽重新上傳</div>
            </div> -->
            <!-- <formTitle title="由教育局發出之小六學生資料表副本 Photocopy of P.6 Student Identification Form (issued by EDB)"></formTitle>
            <div class="upload-box">
                <upload :disabled="isView" :fileType="['pdf','jpeg','jpg','png']" class="upload-list"  @childByValue="childByValueMore('photocopy',index,$event)"  :isImgDom="false"></upload>
                <el-button @click="onAdd(6)" icon="el-icon-plus" type="primary">
                                        增加 Add
                                    </el-button>
                <div class="upload-text">
                    <div class="upload-text-title">Acceptable File Format :</div>
                    <div>Image type : JPEG, PDF</div>
                    <div>File size : 50Mbytes or below</div>
                
                </div>
            </div> -->
            <el-form-item v-if="!isView && !adminEdit" class="from-button-group" label="" style="text-align: center;">
                <el-button  type="success" @click="onBack">
                    返回 Back
                                    </el-button>
                <el-button  type="primary" @click="onSave">
                    儲存 Save
                                    </el-button>
               <!-- <el-button  type="primary" @click="onSaveAndContinue">
                    下一頁 Next
                                    </el-button>-->
                <el-button  type="primary" @click="onSaveAndSubmit">
                    儲存及遞交 Save and Submit
                                    </el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import formTitle from '@/components/formTitle'
import upload from '@/components/upload'
    export default {
    components:{formTitle,upload},
    props:{
        studentFiles:{
            type:Array,
            default:function(){}
        },
         isView:{
            type:Boolean,
            default:false
        },
        adminEdit:{
            type:Boolean,
            default:false
        }
    },
    computed:{
        studentPhoto(){
            return this.studentFiles.filter((v)=>{
                return v.type == 0
            })[0]
        },
        birthCertificate(){
            return this.studentFiles.filter((v)=>{
                return v.type == 1
            })
        },
        scoreSheet(){
            return this.studentFiles.filter((v)=>{
                return v.type == 2
            })
        },
        certificateAward(){
            return this.studentFiles.filter((v)=>{
                return v.type == 3
            })
        },
        achievement(){
            return this.studentFiles.filter((v)=>{
                return v.type == 4
            })
        },
        letterRecommendation(){
            return this.studentFiles.filter((v)=>{
                return v.type == 5
            })
        },
        photocopy(){
            return this.studentFiles.filter((v)=>{
                return v.type == 6
            })[0]
        },
    },
    data() {
      return {
      
      }
    },
    methods: {
      onAdd(type){
           let newFile= {
              type:type,
              path:''
           }
           this.studentFiles.push(newFile)
           this.$forceUpdate()
      },
      childByValue(label,value){
        this[label].path = value
        this.$forceUpdate()
      },
      childByValueMore(label,index,value){
        this[label][index].path = value
        this.$forceUpdate()
      },
       onBack(){
            this.$emit('onStudentFilesBack')
        },
        onSave(){
           this.$emit('onStudentFilesSave')
        },
        onSaveAndContinue(){
           this.$emit('onStudentFilesSaveAndContinue')
        },
        onSaveAndSubmit(){
            this.$emit('onStudentFilesSaveAndSubmit')
        }
    }
    }
</script>

<style lang="scss" scoped>
.document-identity-radio{
    display: flex;
    flex-direction: column;
}
.document-identity-radio .el-radio{
    display: flex;
    margin-bottom: 1.25rem;
}
.el-button--primary{
    width: auto;
}
.upload-box{
  padding: 3.75rem 0;
}
.upload-list{
    margin-bottom: 1.25rem;
}
.upload-text{
    margin-top: 0.625rem;
    line-height: 1.5;
}
.upload-text-title{
    font-size: 1.125rem;
    font-weight: bold;
    
}
::v-deep{
    .el-input__inner{
        border-color: #72ACFF;
    }
}
@media (min-width: $phoneMinWidth) and (max-width: $phoneMaxWidth) {
.from-button-group .el-button{
    margin-bottom: 0.625rem;
  }
.from-button-group .el-button:last-child{
    margin-left: 0;
  }
}
</style>